<template>
  <div id="app" ref="app">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="router_container" :key="key" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="router_container" :key="key" /> -->

    <router-view />

    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" top="33vh"
      :show-close="false" width="500px">
      <div slot="title" class="t-title">
        浏览器不兼容
      </div>
      <div class="t-content"><i class="el-icon-info t-el-icon-info"></i>仅允许Chrome浏览器打开该网站</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadchrome"> 下载 Chrome</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      timer: null,
      dialogVisible: false,
      browerinfo: {}
    }
  },
  mounted() {
    this.browerCheck()
    this.$refs.app.addEventListener('scroll', this.handleScroll, true)
  },
  watch: {
    '$store.state.screenTop': {
      deep: true,
      handler: function (newv, oldv) {
        if (newv == 0 && this.is_click_back_top) {
          // 回到顶部
          const inerval = setInterval(() => {
            this.$refs.app.scrollTop = oldv -= 80
            if (oldv < 0) {
              clearInterval(inerval)
            }
          }, 20)
        }
      }
    }
  },
  computed: {
    ...mapState(['screenTop', 'is_click_back_top'])
  },
  methods: {
    ...mapMutations(['set_state']),
    downloadchrome() {
      let url = 'https://zhongtai-obs.obs.cn-southwest-2.myhuaweicloud.com/tmp/ChromeSetup.exe'
      if (this.browerinfo.os == "Windows") {
        url = 'https://zhongtai-obs.obs.cn-southwest-2.myhuaweicloud.com/tmp/ChromeSetup.exe'
      } else {
        url = 'https://zhongtai-obs.obs.cn-southwest-2.myhuaweicloud.com/tmp/googlechrome.dmg'
      }
      window.open(url)
    },
    browerCheck() {
      let info = new Browser();
      this.browerinfo = info
      this.set_state({ name: 'browerInfo', value: info })
      if (info.browser == "Chrome" || info.browser == "Edge") {
        this.set_state({ name: 'isAllowLogin', value: true })  // 允许登录
        this.dialogVisible = false
      } else {
        this.set_state({ name: 'isAllowLogin', value: false })  // 不允许登录
        this.dialogVisible = true
        localStorage.removeItem('user_info')
        localStorage.removeItem('token')
      }
    },
    handleScroll() {
      let scrollTop = this.$refs.app.scrollTop
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.set_state({ name: 'is_click_back_top', value: false })
        this.set_state({ name: 'screenTop', value: scrollTop })
      }, 200)

    }
  }
}
</script>


<style lang='less'>
@import './assets/css/main.css';
@import './assets/iconfont/iconfont.css';

html,
body {
  height: 100%;
  min-width: 1200px;
  // max-width: 1920px;
  background-color: #f7f7f7;
  margin: 0 auto;
}

.t-title {
  font-size: 26px;
  font-weight: bold;
}

.t-content {
  font-size: 16px;
}

.t-el-icon-info {
  margin-right: 8px;
  font-size: 20px;
  color: #E6A23C;
}

.type_page {
  width: 1200px;
  height: 100%;
  display: flex;
  margin: 0 auto;
  align-items: center;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f7f7f7;
  height: 100%;
  overflow: scroll;
  overflow-x: hidden
}

.el-tooltip__popper {
  max-width: 800px;
  max-width: 52vw;

}

* {
  box-sizing: border-box;
}

.filter-custom {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;

  .label {
    margin-right: 12px;
    font-size: 14px;
  }
}

.table-custom {
  padding: 20px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .downDataToExcel {
    margin-bottom: 20px;
  }

  .pagination {
    margin: 20px;
  }
}

.pagination-custom {
  margin-top: 20px;
}
</style>
